// scene 事件
export const SceneEventList = ['loaded', 'fontloaded', 'maploaded', 'resize', 'destroy', 'dragstart', 'dragging', 'dragend', 'dragcancel'];